const venueTemplate = require('../../templates').venueTemplate;
const roomTemplate = require('../../templates').roomTemplate;

const venueData = Object.assign({}, venueTemplate, {
	id: 'kudosgames-cafe',
	name: 'KudosGames Café',	
	website: 'https://kudosgames.cafe',
	locations: [{
		id: 'middelfart',
		cityId: 'middelfart',
		opened: '20190124',
		address: 'Jernbanegade 39, 5500 Middelfart',
		coordinates: {lng: '55.502047', lat: '9.734274'},
	}],
	rooms: [
		Object.assign({}, roomTemplate, {
			id: 'the-butcher',
			name: {da: 'The Butcher', en: 'The Butcher'},
			languages: ['da', 'en'],
			minutes: 60,
			teamSizeMin: 2,
			locations: [{
				locationId: 'middelfart',
				opened: '20260202',
				closed: null,
				rooms: 1
			}]
		})
	]
});


export {venueData};